import { formatPln } from '../catalog/money';

/** Coordinator's decision I1: the invoiced share of a mixed payment plan (sent only with the invoice amounts). */
export type PlanShare = { invoicedGrosze: number; totalGrosze: number; otherForms: string[] };

/** „Faktura na część z planu płatności: X zł z Y zł (reszta: gotówka/umowa o dzieło)”. */
export const planShareNote = (s: PlanShare): string =>
  `Faktura na część z planu płatności: ${formatPln(s.invoicedGrosze)} z ${formatPln(s.totalGrosze)}${s.otherForms.length > 0 ? ` (reszta: ${s.otherForms.join('/')})` : ''}`;
